import React, { ReactElement, useState } from 'react';
import xss from 'xss';
import HTMLReactParser from 'html-react-parser';
import ReactDOM from 'react-dom';

const ReadMore: React.FC<any> = (data: any): ReactElement => {
  const { text } = data || 'No Description';
  const { textLimit } = data || '150';
  const textLength = text.length;
  const textNoHtml = text.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
  const [isReadMore, setIsReadMore] = useState(true);
  const shouldReadMore = textLength > textLimit;
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  
  return (
    <div className="text">
      {(shouldReadMore && isReadMore)
        ? textNoHtml.slice(0, textLimit)
        : (
          <>{HTMLReactParser(xss(text))}</>
        )}
      {shouldReadMore ? (
        <div>
          <br />
          <span
            onKeyPress={(e) => {
              e.preventDefault();
              toggleReadMore();
            }}
            onClick={(e) => {
              e.preventDefault();
              toggleReadMore();
            }}
            className="read-or-hide"
          >
            {isReadMore
              ? (
                <p className="mt-3">
                  <i className="fas fa-angle-down mr-2" />
                  <span>Read more</span>
                </p>
              ) : (
                <p className="mt-3">
                  <i className="fas fa-angle-up mr-2" />
                  <span>Read Less</span>
                </p>
              )}
          </span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

if (document.getElementsByClassName('react-read-more').length > 0) {
  document.querySelectorAll('.react-read-more')
    .forEach((element) => {
      const text = element.innerHTML;
      const maxTextLength = element.getAttribute('data-max-text-length') || 120;
      ReactDOM.render(<ReadMore text={text} textLimit={maxTextLength} />, element);
    });
}

export default ReadMore;
